/* Kart 2 — görsel noktaları, oklar, beden paneli, renk önizleme, Türkçe fiyat */
(function () {
  if (window.__card2) return;
  window.__card2 = true;

  // Fiyatları "16.999 TL" biçiminde göster (theme.js'in product-form ve hızlı bakış güncellemeleri dahil)
  window.formatMoney = function (cents) {
    var n = Number(cents) / 100;
    var dec = Math.round(n * 100) % 100 !== 0;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: 2 }) + ' TL';
  };

  var bindTrack = function (card) {
    if (card.__c2) return; card.__c2 = true;
    var track = card.querySelector('[data-c2-track]');
    var dots = card.querySelectorAll('.c2-dots i');
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
  };
  // Hareket videoları: ekrana girince yükle ve oynat, çıkınca durdur. Hareket azaltma / veri tasarrufu açıksa poster kalır.
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData);
  var vio = !calm && 'IntersectionObserver' in window && new IntersectionObserver(function (list) {
    list.forEach(function (x) {
      var v = x.target;
      if (x.isIntersecting) {
        if (!v.src) {
          // Kartta Shopify'ın 480p kopyası yeter (~1 MB); ürün sayfasında (data-c2-q="hd") mobilde 720p, masaüstünde asıl dosya. Bulunamazsa asıl dosyaya dön.
          var orig = v.dataset.c2Video;
          var alt = v.dataset.c2Q === 'hd' ? (window.innerWidth < 990 ? 'HD-720p-4.5Mbps' : null) : 'SD-480p-1.5Mbps';
          var small = alt ? orig.replace(/HD-1080p-[\d.]+Mbps/, alt) : orig;
          if (small !== orig) v.addEventListener('error', function () { v.src = orig; v.play().catch(function () {}); }, { once: true });
          v.src = small;
          v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
        }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px 0px', threshold: 0.2 });
  // Videolar sayfa yüklendikten sonra başlar; ilk görseller ve yazı tipleriyle bant genişliği yarışmasın
  var loaded = document.readyState === 'complete';
  if (!loaded) window.addEventListener('load', function () { setTimeout(function () { loaded = true; bindAll(); }, 600); });
  var bindVideo = function (v) { if (vio && loaded && !v.__c2v) { v.__c2v = true; vio.observe(v); } };
  var bindAll = function () {
    document.querySelectorAll('[data-c2]').forEach(bindTrack);
    document.querySelectorAll('[data-c2-video]').forEach(bindVideo);
  };
  bindAll();
  document.addEventListener('DOMContentLoaded', bindAll);
  if ('MutationObserver' in window) new MutationObserver(bindAll).observe(document.documentElement, { childList: true, subtree: true });

  var closeAll = function (except) {
    document.querySelectorAll('.c2.is-open').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-open');
      var b = c.querySelector('[data-c2-bag]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-c2-step]');
    if (step) {
      var t = step.closest('[data-c2]').querySelector('[data-c2-track]');
      t.scrollBy({ left: Number(step.dataset.c2Step) * t.clientWidth, behavior: 'smooth' });
      return;
    }
    var bag = e.target.closest('[data-c2-bag]');
    if (bag) {
      var card = bag.closest('[data-c2]');
      var open = !card.classList.contains('is-open');
      closeAll(card);
      card.classList.toggle('is-open', open);
      bag.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var f = card.querySelector('.c2-sheet__sizes button:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
      return;
    }
    if (e.target.closest('[data-c2-close]')) { closeAll(); return; }
    var add = e.target.closest('.c2-sheet [data-quick-add]');
    if (add) { setTimeout(function () { closeAll(); }, 600); return; }
    if (!e.target.closest('.c2-sheet')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Renk yuvarlağının üzerine gelince kartta o rengi göster
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-c2-swap]');
    if (!sw) return;
    var img = sw.closest('[data-c2]').querySelector('.c2-slide img');
    if (!img) return;
    var card = sw.closest('[data-c2]');
    if (!img.dataset.c2Orig) { img.dataset.c2Orig = img.src; img.dataset.c2OrigSet = img.srcset || ''; }
    img.srcset = ''; img.src = sw.dataset.c2Swap;
    card.classList.add('is-swap');
    sw.addEventListener('mouseleave', function restore() {
      img.src = img.dataset.c2Orig; if (img.dataset.c2OrigSet) img.srcset = img.dataset.c2OrigSet;
      card.classList.remove('is-swap');
      sw.removeEventListener('mouseleave', restore);
    });
  });
})();
